import React from 'react';
import { TwitterIcon, LinkedinIcon, GithubIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-black border-t border-white/5 pt-20 pb-10 relative z-10" data-id="element-29">
      <div className="container mx-auto px-6 md:px-12" data-id="element-30">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-31">
          {/* Brand Column */}
          <div className="md:col-span-1" data-id="element-32">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-33">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-cyan to-brand-blue flex items-center justify-center text-white font-bold text-xl" data-id="element-34">
                N
              </div>
              <span className="text-xl font-bold tracking-tight text-white" data-id="element-35">
                Northvanta
              </span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-36">
              Desarrollo web avanzado, automatización con IA y marketing digital
              orientado a resultados para empresas que buscan escalar.
            </p>
            <div className="flex items-center gap-4 text-gray-400" data-id="element-37">
              <a href="#" className="hover:text-brand-cyan transition-colors" data-id="element-38">
                <TwitterIcon className="w-5 h-5" data-id="element-39" />
              </a>
              <a href="#" className="hover:text-brand-cyan transition-colors" data-id="element-40">
                <LinkedinIcon className="w-5 h-5" data-id="element-41" />
              </a>
              <a href="#" className="hover:text-brand-cyan transition-colors" data-id="element-42">
                <GithubIcon className="w-5 h-5" data-id="element-43" />
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div data-id="element-44">
            <h4 className="text-white font-semibold mb-6" data-id="element-45">Servicios</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-46">
              <li data-id="element-47">
                <a href="#" className="hover:text-brand-cyan transition-colors" data-id="element-48">
                  Desarrollo Web
                </a>
              </li>
              <li data-id="element-49">
                <a href="#" className="hover:text-brand-cyan transition-colors" data-id="element-50">
                  Implementación CRM
                </a>
              </li>
              <li data-id="element-51">
                <a href="#" className="hover:text-brand-cyan transition-colors" data-id="element-52">
                  Automatización IA
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-brand-cyan transition-colors" data-id="element-54">
                  Marketing Digital
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-55">
            <h4 className="text-white font-semibold mb-6" data-id="element-56">Empresa</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-57">
              <li data-id="element-58">
                <a href="#valor" className="hover:text-brand-cyan transition-colors" data-id="element-59">
                  Por qué nosotros
                </a>
              </li>
              <li data-id="element-60">
                <a href="#proceso" className="hover:text-brand-cyan transition-colors" data-id="element-61">
                  Proceso
                </a>
              </li>
              <li data-id="element-62">
                <a href="#testimonios" className="hover:text-brand-cyan transition-colors" data-id="element-63">
                  Casos de éxito
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="hover:text-brand-cyan transition-colors" data-id="element-65">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-66">
            <h4 className="text-white font-semibold mb-6" data-id="element-67">Contacto</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-68">
              <li className="flex items-center gap-2" data-id="element-69">
                <MailIcon className="w-4 h-4" data-id="element-70" />
                <a href="mailto:hello@northvanta.com" className="hover:text-brand-cyan transition-colors" data-id="element-71">
                  hello@northvanta.com
                </a>
              </li>
              <li data-id="element-72">Av. Tecnológica 123, Ciudad Digital</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-500" data-id="element-73">
          <p data-id="element-74">
            © {new Date().getFullYear()} Northvanta. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-4" data-id="element-75">
            <a href="#" className="hover:text-white transition-colors" data-id="element-76">
              Términos de servicio
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-77">
              Política de privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}